import React from 'react';
import './Thecommonty.css';
import thecomm from '../../../imgs/thecommun.webp';

const Thecommonty = () => {
    return (
        <div className="Thecom-container">
            <div className='Cavitys'>
                <h2 className="Thecom-title">The Common Types of PET Preforms</h2>
                <p className="Thecom-date">Nov. 16, 2022</p>

                <div className="Thecom">
                    <img src={thecomm} alt="72 Thecom PET Preforms Machine" className="Thecom-image" />
                    <div className="Thecom-content">

                        <p className="Thecom-text">
                            A preform is an intermediate product that is then blown into polyethylene terephthalate (PET) containers. The neck size, weight, color and shape of the preforms vary. Powerjet preform injection molding machines that are specially designed to meet the needs of customers in different market segments! </p>

                        <p className="Thecom-text">
                            Preforms are mainly used in the manufacture of packaged mineral water, carbonated soft drinks, and edible oils. In addition, preforms are used in many fields such as food jars, detergent and cosmetic packaging, and medicine bottles.</p>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Thecommonty;
